import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { CodedValueService } from './coded-value.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  private timezones = [
    { merchantNo: 0, sourceTz: 'UTC+05:30', displayTz: 'UTC+05:30', faceTz: undefined },
    { merchantNo: 57, sourceTz: 'UTC+05:30', displayTz: 'UTC+05:30', faceTz: undefined },// credeze UAT
    { merchantNo: 59, sourceTz: 'UTC+05:30', displayTz: 'UTC+04:00', faceTz: undefined },// Bhima UAT
    { merchantNo: 10, sourceTz: 'UTC+00:00', displayTz: 'UTC+05:30', faceTz: undefined }, // Akasa Air
    { merchantNo: 68, sourceTz: 'UTC+05:30', displayTz: 'UTC+04:00', faceTz: undefined } // Bhima prod
  ];

  constructor(private codedValueService: CodedValueService) {
    this.timezones.forEach(tz => {
      tz.faceTz = this.calculateFaceTz(tz.sourceTz, tz.displayTz);
    });
    // this.getMerchantTimezone();
  }

  public calculateFaceTz(sourceTz: string, displayTz: string): string {
    const data1 = this.getTimezoneOffset(sourceTz);
    const data2 = this.getTimezoneOffset(displayTz);

    let d = data2 - data1;

    const face = d < 0 ? 'UTC-' : 'UTC+';
    d = Math.abs(d);

    return `${face}${Math.floor(d / 60)}:${d % 60}`;
  }

  private getTimezoneOffset(timezone: string): number {
    const withoutUTC = timezone.replace('UTC', '');
    const [hours, minutes] = withoutUTC.split(':');
    let offset = Number(hours) * 60;
    if (minutes) {
      offset += Number(minutes);
    }
    return offset;
  }

  localUserDetails = null;
  selectedZt = null;

  getMerchantTimezone() {
    if (this.selectedZt && this.localUserDetails) {
      return of(this.selectedZt);
    } else {
      return this.codedValueService.getUserDetails().pipe(map(res => {
          this.localUserDetails = res;
          const usrMerchantNo = this.localUserDetails.usrMerchantNo;
          const selectTz = this.timezones.find(tz => tz.merchantNo == usrMerchantNo);
          this.selectedZt = this.timezones[0]
          if (selectTz) {
            this.selectedZt = selectTz;
          }
          return this.selectedZt;
        })
      );
    }
  }


  public reverseTimezone(date: Date, sourceTz: string, targetTz: string): string {
    const sourceOffset = this.getTimezoneOffset(sourceTz);
    const targetOffset = this.getTimezoneOffset(targetTz);
    const offsetDifference = targetOffset - sourceOffset;

    // const parsedDate = typeof date === 'string' ? new Date(date.replace(' ', 'T') + 'Z') : date;
    // if (isNaN(parsedDate.getTime())) {
    //   throw new Error('Invalid date provided');
    // }

    // Revert the timezone adjustment
    const revertedDate = new Date(date.getTime() - offsetDifference * 60 * 1000);

    // Format as 'YYYY-MM-DD HH:mm:ss'
    const yyyy = revertedDate.getFullYear();
    const mm = String(revertedDate.getMonth() + 1).padStart(2, '0');
    const dd = String(revertedDate.getDate()).padStart(2, '0');
    const hh = String(revertedDate.getHours()).padStart(2, '0');
    const min = String(revertedDate.getMinutes()).padStart(2, '0');
    const ss = String(revertedDate.getSeconds()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  }

}
